var _a;
let todoWhenDfpServiceEnabled = [];
let dfpServiceEnabled = false;
// DEBUGGING: use GPC console https://developers.google.com/publisher-tag/guides/publisher-console
export function onGoogleDfpNotLoaded(cb) {
    document.addEventListener('googletag:notloaded', cb, { once: true });
}
//function waitForConsent(): Promise<boolean> {
//    return new Promise(async (resolve, reject) => {
//        const check = () => {
//            if (window.Cookiebot?.consent) {
//                if (window.Cookiebot.consent.marketing) {
//                    resolve(true);
//                } else {
//                    reject();
//                }
//                return true;
//            }
//            return false;
//        };
//
//        if (!check()) {
//            window.addEventListener('CookiebotOnAccept', check);
//            window.addEventListener('CookiebotOnDecline', () => reject());
//        }
//    });
//}
export function runGoogleDfp() {
    addGoogleDfpCmd(() => {
        if (!googletag._loadStarted_ && !googletag._loaded_) {
            console.warn('Google DFP not loaded');
            document.dispatchEvent(new Event('googletag:notloaded'));
            return;
        }
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs(true);
        googletag.pubads().setTargeting("url", location.pathname);
        googletag.enableServices();
        dfpServiceEnabled = true;
        for (const cmd of todoWhenDfpServiceEnabled) {
            cmd();
        }
        todoWhenDfpServiceEnabled = [];
    });
}
export function addGoogleDfpCmd(command) {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(command);
}
export function onGoogleDfpServicesEnabled(callback) {
    if (dfpServiceEnabled) {
        callback();
    }
    else {
        todoWhenDfpServiceEnabled.push(callback);
    }
}
export var AdSize;
(function (AdSize) {
    AdSize["HugePanorama"] = "panorama-huge";
    AdSize["SmallPanorama"] = "panorama-small";
    AdSize["StandardPanorama"] = "panorama";
    AdSize["SmallBanner"] = "banner-small";
    AdSize["StandardBanner"] = "banner";
})(AdSize || (AdSize = {}));
export const AdFormats = Object.freeze({
    [AdSize.HugePanorama]: [[1080, 240], [320, 320]],
    [AdSize.StandardPanorama]: [[980, 240], [320, 320]],
    [AdSize.SmallPanorama]: [[600, 120], [320, 160]],
    [AdSize.StandardBanner]: [[300, 600], [320, 160]],
    [AdSize.SmallBanner]: [[300, 250], [320, 80]],
});
// Compensate for scrollbar width
const scrollbarWidth = window.innerWidth - (((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) || 0) - 1;
// NOTE: Remember to sync breakpoints with @media queries for adverts themselves
// NOTE: Using Math.round to avoid issues with fractional pixels - DFP expects numbers to be integers
export const SizeMappings = Object.freeze({
    [AdSize.HugePanorama]: () => googletag.sizeMapping()
        .addSize([Math.round(640 - scrollbarWidth), 0], AdFormats[AdSize.HugePanorama][0])
        .addSize([0, 0], AdFormats[AdSize.HugePanorama][1])
        .build(),
    [AdSize.StandardPanorama]: () => googletag.sizeMapping()
        .addSize([Math.round(640 - scrollbarWidth), 0], AdFormats[AdSize.StandardPanorama][0])
        .addSize([0, 0], AdFormats[AdSize.StandardPanorama][1])
        .build(),
    [AdSize.SmallPanorama]: () => googletag.sizeMapping()
        .addSize([Math.round(768 - scrollbarWidth), 0], AdFormats[AdSize.SmallPanorama][0])
        .addSize([0, 0], AdFormats[AdSize.SmallPanorama][1])
        .build(),
    [AdSize.StandardBanner]: () => googletag.sizeMapping()
        .addSize([Math.round(768 - scrollbarWidth), 0], AdFormats[AdSize.StandardBanner][0])
        .addSize([0, 0], AdFormats[AdSize.StandardBanner][1])
        .build(),
    [AdSize.SmallBanner]: () => googletag.sizeMapping()
        .addSize([Math.round(768 - scrollbarWidth), 0], AdFormats[AdSize.SmallBanner][0])
        .addSize([0, 0], AdFormats[AdSize.SmallBanner][1])
        .build(),
});
